import { render, staticRenderFns } from "./EmailActivation.vue?vue&type=template&id=4a6d1ca8&scoped=true&"
import script from "./EmailActivation.vue?vue&type=script&lang=js&"
export * from "./EmailActivation.vue?vue&type=script&lang=js&"
import style0 from "./EmailActivation.vue?vue&type=style&index=0&id=4a6d1ca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6d1ca8",
  null
  
)

export default component.exports